import script from "./version-permission.vue?vue&type=script&setup=true&lang=js"
export * from "./version-permission.vue?vue&type=script&setup=true&lang=js"

import "./version-permission.vue?vue&type=style&index=0&id=8151cf86&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8151cf86"]])

export default __exports__